// extracted by mini-css-extract-plugin
export default {"list":"YD4IM","automaticAds":"m_eTg","slot":"OdV9M","overwrite":"qxcuM","divider":"kv5wV","info":"wxRrj","icon":"mipq1","adText":"H8jW_","overwriteText":"ITn30"};